import SalarySummary from "../components/SalarySummary/SalarySummary";
import {PERM} from "../utilites/permissions";

const salarySummary = [
  {
    path: '/salary_summary',
    name: 'SalarySummary',
    component: SalarySummary,
    meta: {requiresAuth: true,
      permissions: [
        PERM.STAFF,
      ]
    },
    props: true,
  },
];

export default salarySummary;



// WEBPACK FOOTER //
// ./src/router/salarySummary.js